{
  "name": "@uppy/golden-retriever",
  "description": "The GoldenRetriever Uppy plugin saves selected files in browser cache to seamlessly resume uploding after browser crash or accidentally closed tab",
  "version": "6.0.1",
  "license": "MIT",
  "type": "module",
  "sideEffects": [
    "lib/ServiceWorker.js"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build",
    "test": "vitest run --silent='passed-only'"
  },
  "keywords": [
    "file uploader",
    "restore files",
    "crash recovery",
    "golden retriever",
    "resumable uploads",
    "uppy",
    "uppy-plugin"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./lib/ServiceWorker.js": "./lib/ServiceWorker.js",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "lodash": "^4.18.1"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "@uppy-dev/msw-setup": "workspace:^",
    "@uppy-dev/tsconfig": "workspace:^",
    "@uppy/core": "workspace:^",
    "@uppy/dashboard": "workspace:^",
    "@uppy/xhr-upload": "workspace:^",
    "@vitest/browser-playwright": "^5.0.3",
    "playwright": "1.64.0",
    "typescript": "^6.0.3",
    "vitest": "^5.0.3"
  }
}
